<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle
          :title="$t('page_title.tags_item')"
          :butShow="true"
          :newButShow="true"
          @newBut="newBut('add')"
        ></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ baseMtagItem_name: true }" />
        <myTable
          ref="table"
          :columns="columns"
          :params="{cat_id:id}"
          requestUrl="base-mtag-item/list"
          :showPage="true"
        >
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Icon
              v-if="data.row.children  && data.row.cat_id == 3"
              class="cursor_p mg-left15"
              type="md-add-circle"
              size="24"
              color="#1F8FC8"
              @click="newBut('add',data.row)"
            />
            <Poptip
              v-if="!data.row.children  && data.row.cat_id == 3"
              placement="bottom"
              confirm
              :title="$t('confirm_delete')"
              @on-ok="handleDel(data.row)"
            >
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>
          </template>
        </myTable>
      </div>
    </div>
    <edit v-if="modal" @onOk="onOk" :type="type" :modal="modal" :itemObj="itemObj" @cancel="cancel"></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import edit from "./module/baseMtag_item_edit";
import myTableFilter from "@/components/myTableFilter";
export default {
  name: "baseMtag",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "id",
          align: "center",
          tree: true,
          width: 150,
        },
        {
          title: this.$t("Tags.names") + "(EN)",
          key: "en_cname",
          align: "center"
        },
        {
          title: this.$t("Tags.names") + "(繁体)",
          key: "zh-tw_cname",
          align: "center"
        },
        {
          title: this.$t("Tags.names") + "(简体)",
          key: "zh-cn_cname",
          align: "center"
        },
        {
          title: this.$t("home.school"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.school == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus2(params.row.tag_id, "school");
                }
              }
            });
          }
        },
        {
          title: this.$t("Teaching_Staff"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.teacher == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus2(params.row.tag_id, "teacher");
                }
              }
            });
          }
        },
        {
          title: this.$t("Non_Teaching_Staff"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.staff == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus2(params.row.tag_id, "staff");
                }
              }
            });
          }
        },
        {
          title: this.$t("status"),
          key: "tag_status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.tag_status == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus(params.row.tag_id);
                }
              }
            });
          }
        },
        {
          title: this.$t("Info.order"),
          key: "sort_id",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 180,
        },
      ],
      modal: false,
      itemObj: {},
      type: "add",
      id: this.$base.getRequest().id
    };
  },
  created () {
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      params.cat_id = this.id
      this.$refs.table.reSearch(params);
    },
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    setStatus2 (tag_id, type) {
      this.$base.showLoading();
      this.$request.sendPost(
        'base-mtag-item/upd_roles',
        { tag_id: tag_id, role: type },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
    setStatus (tag_id) {
      this.$base.showLoading();
      this.$request.sendPost(
        'base-mtag-item/upd_status',
        { tag_id: tag_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
    handleDel (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        'base-mtag-item/del ',
        { tag_id: item.tag_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$refs.table.getLoad();
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/baseMtag/baseMtag_item.vue